import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const ACCOUNT = {
  MY_ACCOUNT: {
    method: 'GET',
    url: `${SERVER_API}/account/user-info`,
  } as IEndpointData,
  MY_ACCOUNT_UPDATE: {
    method: 'POST',
    url: `${SERVER_API}/account/user-info`,
  } as IEndpointData,
  MY_ORGANIZATIONS: {
    method: 'GET',
    url: `${SERVER_API}/account/my-organizations`,
  } as IEndpointData,
  MY_PROFILES: {
    method: 'GET',
    url: `${SERVER_API}/account/my-profiles`,
  } as IEndpointData,
  MY_HOUSEHOLD: {
    method: 'GET',
    url: `${SERVER_API}/account/my-household`,
  } as IEndpointData,
  CHANGE_PASSWORD: {
    method: 'POST',
    url: `${SERVER_API}/account/change-password`,
  } as IEndpointData,
};
